import { createClient } from '@supabase/supabase-js'
import { assertLocalFrontendIsolation } from './localEnvironment'
import { assertStagingFrontendIsolation } from './stagingEnvironment'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY
const localTestMode = process.env.REACT_APP_LOCAL_TEST_MODE === 'true'

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env.local file.')
}

assertLocalFrontendIsolation({
  enabled: localTestMode,
  supabaseUrl,
  siteUrl: process.env.REACT_APP_SITE_URL,
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
})

assertStagingFrontendIsolation({
  enabled: process.env.REACT_APP_STAGING_TEST_MODE,
  supabaseUrl,
  siteUrl: process.env.REACT_APP_SITE_URL,
  localMode: process.env.REACT_APP_LOCAL_TEST_MODE,
  fixtureMode: process.env.REACT_APP_LOCAL_FIXTURE_MODE,
  stripeKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
})

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
